import { render, staticRenderFns } from "./MultiLangArticleMaintain.vue?vue&type=template&id=be6fe72a&scoped=true"
import script from "./MultiLangArticleMaintain.vue?vue&type=script&lang=js"
export * from "./MultiLangArticleMaintain.vue?vue&type=script&lang=js"
import style0 from "./MultiLangArticleMaintain.vue?vue&type=style&index=0&id=be6fe72a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6fe72a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6fe72a')) {
      api.createRecord('be6fe72a', component.options)
    } else {
      api.reload('be6fe72a', component.options)
    }
    module.hot.accept("./MultiLangArticleMaintain.vue?vue&type=template&id=be6fe72a&scoped=true", function () {
      api.rerender('be6fe72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/i18n/MultiLangArticleMaintain.vue"
export default component.exports